import { GridStackedHeaderColumn } from '.';

export interface GridStackedHeaderRow {
  stackedHeaderColumns: GridStackedHeaderColumn[];
}
